import React, { useEffect, useState, useMemo } from "react";
import { getFetch, postFetch } from "../../../../../fetch/fetch";
import { Select, Option, Button, IconButton, Modal, Sheet, ModalClose } from "@mui/joy";
import { DataGridPremium, GridFilterModel, GridRowModel, GridToolbar } from "@mui/x-data-grid-premium";

import { createStyles, makeStyles } from '@mui/styles';
import { createTheme, darken, lighten } from '@mui/material/styles';
import useStyles from "../etc/useStyles";
import { dateToDateString } from "../../etc/etcfunctions";
import { Delete, Image, Info, Reorder } from "@mui/icons-material";
import ImageModal2 from "../../../use/imagemodal2";
import PaidModal from "../etc/paidmodal";

import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Backdrop, CircularProgress, InputBase, ToggleButton, ToggleButtonGroup } from "@mui/material";
import totalLocationData from "../../../../../data/locationdata";
import BlockIcon from '@mui/icons-material/Block';

const TotalPayementList: React.FC<any> = (props) => {

    const [selectedMonth, setSelectedMonth] = useState<string>(() => {
        const now = new Date();
        const date = new Date(now.getFullYear(), now.getMonth() + 1, 1);
        return date.getFullYear() + "-" + ("0" + (date.getMonth() + 1)).slice(-2);
    });

    const [imageSrc, setImageSrc] = useState<string>("");
    const [open3, setOpen3] = useState<boolean>(false);

    const [loadingMap, setLoadingMap] = useState<{ [key: string]: boolean }>({});

    const [update, setUpdate] = useState<number>(0);
    const [data, setData] = useState<any>(null);

    const [alignment, setAlignment] = useState<string | null>('total');
    const [alignment2, setAlignment2] = useState<string | null>('total');
    const [alignment3, setAlignment3] = useState<string | null>('total');

    const [open, setOpen] = useState<boolean>(false);

    const setRowLoading = (orderId: string, isLoading: boolean) => {
        setLoadingMap(prev => ({ ...prev, [orderId]: isLoading }));
    };

    const [rows, setRows] = useState<any[]>([]);
    const [btnLoading, setBtnLoading] = useState<boolean>(false);

    //결제내역 팝업(PaidModal)용 state
    const [totalTeacherData, setTotalTeacherData] = useState<any[]>([]);
    const [registerPayInfo, setRegisterPayInfo] = useState<any[]>([]);
    const registerPayInfoFetched = React.useRef<boolean>(false);
    const [paidModalOpen, setPaidModalOpen] = useState<boolean>(false);
    const [paidModalStudent, setPaidModalStudent] = useState<any>(null);
    const [selectedPaidOrderItems2, setSelectedPaidOrderItems2] = useState<any[]>([]);



    const submitCancel = async (id: number, column: string) => {

        if (!id || !column) {
            return;
        }

        try {

            setBtnLoading(true);

            const response = await fetch("https://peetsunbae.com/dashboard/payments/managepayments/submitcancel", {
                method: "POST",
                credentials: "include",
                headers: {
                    "content-type": "application/json"
                },
                body: JSON.stringify({
                    id, column
                })
            });

            const result = await response.json();

            if (result.message === "success") {
                getTotalPaymentList();
                setBtnLoading(false);
            }

        } catch (e) {
            setBtnLoading(false);
        }

    }

    const submitCheck = async (id: number, column: string) => {

        if (!id || !column) {
            return;
        }

        try {

            setBtnLoading(true);

            const response = await fetch("https://peetsunbae.com/dashboard/payments/managepayments/submitcheck", {
                method: "POST",
                credentials: "include",
                headers: {
                    "content-type": "application/json"
                },
                body: JSON.stringify({
                    id, column
                })
            });

            const result = await response.json();

            if (result.message === "success") {
                getTotalPaymentList();
                setBtnLoading(false);
            }

        } catch (e) {
            
        }

    }


    const columns = useMemo<any>(() => [
        {
            field: "goodId", headerName: "상품ID", width: 60
        },
        {
            field: "paymentId", headerName: "결제ID", width: 80
        },
        {
            field: "name", headerName: "학생이름", width: 100
        },
        {
            field: "paidListBtn", headerName: "결제내역", width: 80, sortable: false, filterable: false, renderCell: (params: any) => {

                if (!params.row.userId) {
                    return (<div></div>)
                }

                return (
                    <IconButton
                        color="neutral"
                        onClick={() => {
                            openPaidModal(params.row);
                        }}
                    >
                        <Reorder />
                    </IconButton>
                )
            }
        },
        {
            field: "studentLocation", headerName: "지점", width: 100
        },
        {
            field: "paymentLocation", headerName: "결제지점", width: 100
        },
        {
            field: "goodName", headerName: "상품명", width: 200
        },
        {
            field: "duplicateGoodName", headerName: "중복 상품명", width: 250
        },
        {
            field: "price", headerName: "상품금액", width: 90
        },
        {
            field: "kindName", headerName: "결제종류", width: 100
        },
        {
            field: "status", headerName: "결제상태", width: 100
        },
        {
            field: "statusNumber", headerName: "결제상태번호", width: 120
        },
        {
            field: "amount", headerName: "결제금액", width: 100
        },
        {
            field : "approvalnum", headerName : "승인번호", width : 100
        },
        {
            field : "approvaldt", headerName : "승인일자", width : 150
        },
        {
            field: "authority", headerName: "고유번호", width: 100
        },
        {
            field: "forceImg", headerName: "증빙사진", width: 60, renderCell: (params: any) => {

                const id = params.row.id;
                const userId = params.row.userId;

                if (params.value) {

                    return (
                        <div
                            onClick={(e: any) => {
                                console.log(params.value);
                                setImageSrc(params.value);
                                setOpen3(true);

                            }}
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                width: "100%",
                                height: "100%",
                                cursor: "pointer"
                            }}>
                            <Image color="success" />
                        </div>
                    )

                } else {
                    return (
                        <div style={{

                        }}>
                            -
                        </div>
                    )
                }

            }
        },
        {
            field: "createdAt", headerName: "결제일자", width: 200
        },
        {
            field: "cancelBtn", headerName: "결제취소", width: 120,
            sortable: false,
            renderCell: (params: any) => {
                const index = params.row.index;
                const toBeCanceled = params.row.toBeCanceled;
                const orderId = params.row.orderId;

                const isLoading = !!loadingMap[orderId];

                const goToBeCanceled = async () => {

                    console.log("orderId");
                    console.log(orderId);

                    if (!window.confirm("정말로 해당 결제를 결제취소 예정으로 변경하시겠습니까?")) {
                        return;
                    }

                    setRowLoading(orderId, true);

                    const result: any = await postFetch("/dashboard/payments/managepayment/toBeCanceled", {
                        orderId
                    });

                    setRowLoading(orderId, false);

                    if (result.message === "success") {
                        notify1();
                        setUpdate(Math.random());
                    }
                }

                //취소예정 해제 - 원래 상태로 되돌리기
                const goRevertToBeCanceled = async () => {

                    if (!window.confirm("정말로 취소예정을 해제하고 원래 상태로 되돌리시겠습니까?")) {
                        return;
                    }

                    setRowLoading(orderId, true);

                    const result: any = await postFetch("/dashboard/payments/managepayment/revertToBeCanceled", {
                        orderId
                    });

                    setRowLoading(orderId, false);

                    if (result.message === "success") {
                        notify1();
                        setUpdate(Math.random());
                    } else {
                        notify8();
                    }
                }

                const goCancelPayment = async () => {

                    if (!window.confirm("정말로 해당 결제를 취소시키겠습니까?")) {
                        return;
                    }

                    setRowLoading(orderId, true);

                    if (params.row.type === "payTeacher") {

                        const checkIfOrderItemIsZero = async () => {
                            const orderId = params.row.orderId;
                            const result: any = await postFetch("/dashboard/payments/managepayments/checkiforderitemiszero", {
                                orderId
                            });
                            return result.isZero;
                        }

                        const payTeacherBillId = params.row.payTeacherBillId;
                        console.log("payTeacherBillId");
                        console.log(payTeacherBillId);

                        const result: any = await postFetch("/dashboard/payments/managepayments/destroyorcancelpaymentlink", {
                            type: "cancel",
                            billId: payTeacherBillId
                        });

                        if (result.message === "success") {

                            await checkIfOrderItemIsZero();

                            notify1();
                            setUpdate(Math.random());
                            //남은 결제금액이 0이면 order_item 삭제시키기
                        } else {
                            notify8();
                            alert(result.detail);
                        }

                    }

                    if (params.row.type === "terminal" || params.row.type === "forcePayment" || params.row.type === "withdrawal") {

                        const checkIfOrderItemIsZero = async () => {
                            const orderId = params.row.orderId;
                            const result: any = await postFetch("/dashboard/payments/managepayments/checkiforderitemiszero", {
                                orderId
                            });
                            return result.isZero;
                        }

                        const paymentId = params.row.id;
                        console.log("paymentId");
                        console.log(paymentId);

                        const result: any = await postFetch("/dashboard/payments/managepayments/cancelconfirmpayment", {
                            paymentId,
                            type: params.row.type
                        })

                        if (result.message === "success") {

                            await checkIfOrderItemIsZero();

                            notify1();
                            setUpdate(Math.random());

                        } else {
                            notify8();
                            alert(result.detail);
                        }

                    }

                    setRowLoading(orderId, false);

                }


                if (index > 0 && !toBeCanceled) {
                    return (<div></div>);
                }

                if (index === 0 && !toBeCanceled) {
                    return (
                        <Button
                            variant="outlined"
                            color="neutral"
                            size="sm"
                            onClick={() => {
                                goToBeCanceled();
                            }}
                            fullWidth
                            loading={isLoading}
                        >
                            결제취소 예정
                        </Button>
                    )
                }

                if (toBeCanceled && params.row.type === "payTeacher" && !params.row.canceledAt) {
                    return (
                        <div style={{ display: "flex", gap: "6px" }}>
                            <Button
                                variant="outlined"
                                color="danger"
                                size="sm"
                                onClick={() => {
                                    goCancelPayment();
                                }}
                                sx={{ flexShrink: 0, whiteSpace: "nowrap" }}
                                loading={isLoading}
                            >
                                취소시키기
                            </Button>
                            <Button
                                variant="outlined"
                                color="neutral"
                                size="sm"
                                onClick={() => {
                                    goRevertToBeCanceled();
                                }}
                                sx={{ flexShrink: 0, whiteSpace: "nowrap" }}
                                loading={isLoading}
                            >
                                취소예정 해제
                            </Button>
                        </div>
                    )
                }

                if (toBeCanceled && (params.row.type === "terminal" || params.row.type === "forcePayment" || params.row.type === "withdrawal") && !params.row.canceledAt) {

                    return (
                        <div style={{ display: "flex", gap: "6px" }}>
                            <Button
                                variant="outlined"
                                color="danger"
                                size="sm"
                                onClick={() => {
                                    goCancelPayment();
                                }}
                                sx={{ flexShrink: 0, whiteSpace: "nowrap" }}
                                loading={isLoading}
                            >
                                취소확정
                            </Button>
                            <Button
                                variant="outlined"
                                color="neutral"
                                size="sm"
                                onClick={() => {
                                    goRevertToBeCanceled();
                                }}
                                sx={{ flexShrink: 0, whiteSpace: "nowrap" }}
                                loading={isLoading}
                            >
                                취소예정 해제
                            </Button>
                        </div>

                    )

                }
            }
        },
        {
            field: "canceledAt", headerName: "취소일자", width: 200
        },
        {
            field : "cashReceiptPhoneNumber", headerName : "현금영수증 전화번호", width : 150
        },
        {
            field: 'cashReceiptFinish', headerName: '현금영수증 처리상태', width: 150, filterable: true, renderCell: (params : any) => {

                const id = params.row.id;
                const userId = params.row.userId;

                if (params.value) {

                    //params.value = "11__고용범__1634696828761" 꼴;

                    const name = params.value.split("__")[1];
                    const time = params.value.split("__")[2];
                    const date = new Date(+time);

                    //datestring으로 ~월 ~일 ~시 ~분 꼴로 만들기
                    const dateString = `${date.getMonth() + 1}/${date.getDate()}일 ${date.getHours() < 10 ? "0" + date.getHours() : date.getHours()}:${date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()}`;

                    return (
                        <span>
                            {name} {dateString} &nbsp;
                            <Button variant="soft" size="sm" color="neutral"
                                sx={{
                                    marginLeft: "30px"
                                }}
                                onClick={(e: any) => {
                                    submitCancel(id, params.field);
                                }}
                                loading={btnLoading}
                            >
                                취소하기
                            </Button>
                        </span>
                    )
                } else {
                    return (
                        <Button variant="soft" size="sm" color="neutral"
                            onClick={(e: any) => {
                                submitCheck(id, params.field);
                            }}
                            loading={btnLoading}
                        >
                            <BlockIcon />
                        </Button>
                    )
                }

            }
        },
        {
            field: "detail", headerName: "상세내역", width: 120, renderCell: (params: any) => {
                if (params.row.data) {
                    return (
                        <IconButton
                            color="neutral"
                            onClick={() => {
                                setData(params.row.data);
                                setOpen(true);
                            }}
                        >
                            <Info />
                        </IconButton>
                    )
                } else {
                    return (<div></div>)
                }
            }
        },
        {
            field : "delete", headerName : "삭제하기", width : 120, renderCell : (params : any) => {

                const id = params.row.id;

                const deletePaymentRecord = async () => {
                    if (!window.confirm("정말로 해당 결제 기록을 삭제하시겠습니까?")) {
                        return;
                    }

                    setSubmitLoading(true);

                    const result: any = await postFetch("/dashboard/payments/managepayments/deletepaymentrecord", {
                        paymentId : id
                    });

                    setSubmitLoading(false);

                    if(result.message === "success"){
                        notify1();
                        setUpdate(Math.random());
                    } else {
                        notify8();
                        alert(result.detail);
                    }
                }

                if(params.row.type === "payTeacher"){
                    return (<div></div>);
                }

                return (
                    <div>
                        <IconButton
                            color="neutral"
                            onClick={() => {
                                deletePaymentRecord();
                            }}
                        >
                            <Delete />
                        </IconButton>
                    </div>
                )

            }
        }
    ], [update, loadingMap]);
    const [loading, setLoading] = useState<boolean>(false);
    const [submitLoading, setSubmitLoading] = useState<boolean>(false);

    const [selectedRow, setSelectedRow] = useState<any>(null);
    const [selectedOrderId, setSelectedOrderId] = useState<string>("");
    const [selectedBillId, setSelectedBillId] = useState<string>("");

    const [selectedIsFinish, setSelectedIsFinish] = useState<boolean>(false);
    const [searchName, setSearchName] = useState<string>("");

    const [filterModel, setFilterModel] = useState<GridFilterModel>({
        items: [
            {
                id: 1,
                field: "name",
                operator: "contains",
                value: ""
            },
            {
                id: 2,
                field: "kindName",
                operator: "contains",
                value: ""
            },
            {
                id: 3,
                field: "status",
                operator: "contains",
                value: ""
            },
            {
                id: 5,
                field: "studentLocation",
                operator: "isAnyOf",
                value: []
            },
            {
                id: 6,
                field: "statusNumber",
                operator: "contains",
                value: ""
            }
        ],
    });

    const notify1 = () => toast.success("성공했습니다", {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: true,
        theme: "light"
    })

    const notify8 = () => toast.error("실패했습니다", {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: true,
        theme: "light"
    })

    const notify9 = () => toast.success("결제 취소에 성공했습니다", {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: true,
        theme: "light"
    })

    const notify16 = () => toast.success("결제취소 예정으로 변경되었습니다", {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: true,
        theme: "light"
    })

    const notify18 = () => toast.success("환불 청구상품이 생성되었습니다", {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: true,
        theme: "light"
    })


    const classes = useStyles();

    const getTotalPaymentList = async () => {

        try {

            const result: any = await getFetch("/dashboard/payments/totalpaymentlist?selectedMonth=" + selectedMonth + "&withDuplicates=1");

            console.log("result");
            console.log(result);

            const orderItemsData = result.orderItemsData;
            const teacherData = result.teacherData;

            setTotalTeacherData(teacherData ? [...teacherData] : []);

            start(orderItemsData, teacherData);

        } catch (e) {
            console.log(e);
        }

    }

    useEffect(() => {

        getTotalPaymentList();

    }, [selectedMonth, update]);

    //환불상품 "일할" 모드에서만 필요해서 팝업 첫 오픈 시 lazy하게 1회만 가져옴
    const fetchRegisterPayInfo = async () => {

        if (registerPayInfoFetched.current) {
            return;
        }

        try {

            const result: any = await getFetch("/dashboard/payments/managepayment/gettotaluserlist");

            if (result && result.registerPayInfo) {
                setRegisterPayInfo([...result.registerPayInfo]);
                registerPayInfoFetched.current = true;
            }

        } catch (e) {
            console.log(e);
        }

    }

    const getSelectedStudentInfo = async (userId: number) => {

        try {

            const result: any = await getFetch("/dashboard/payments/managepayment/getselectedstudentinfo?userId=" + userId);

            console.log(result);

            if (result.message === "success") {
                setSelectedPaidOrderItems2(result.data.orderItemsData ? [...result.data.orderItemsData] : []);
            }

        } catch (e) {
            console.log(e);
        }

    }

    const openPaidModal = async (row: any) => {

        if (!row.userId) {
            return;
        }

        setPaidModalStudent({ id: row.userId, name: row.name, location: row.studentLocation });

        fetchRegisterPayInfo();

        setSubmitLoading(true);
        await getSelectedStudentInfo(row.userId);
        setSubmitLoading(false);

        setPaidModalOpen(true);

    }

    //팝업 안에서 취소 등 액션 시 setUpdate가 호출되면 팝업 내용도 같이 갱신
    useEffect(() => {

        if (!paidModalOpen || !paidModalStudent) {
            return;
        }

        getSelectedStudentInfo(paidModalStudent.id);

    }, [update]);

    const handleEditCommit = React.useCallback(
        async (newRow: GridRowModel, old: any) => {
            var field = "";


            for (const [key, value] of Object.entries(newRow)) {
                if (value !== old[key]) {
                    field = key;

                }
            }

            const cellValue = newRow[field] ? newRow[field] : "";

            if (field === "memo") {

                fetch("https://peetsunbae.com/dashboard/payments/managepayment/updatememofornewpaylink", {
                    method: "POST",
                    headers: { "content-type": "application/json" },
                    credentials: "include",
                    body: JSON.stringify({
                        id: newRow.id,
                        value: cellValue,
                        field
                    })
                }).then((response: any) => {
                    response.json()
                        .then((result: any) => {

                        })
                })
            }

            return newRow;
        }, []
    );

    const handleProcessRowUpdateError = React.useCallback((error: Error) => {

        alert(error.message);
    }, []);

    const start = (selectedPaidOrderItems: any[], teacherData: any[]) => {


        if (!selectedPaidOrderItems || selectedPaidOrderItems.length === 0) {
            setRows([]);
            return;
        }

        const newRows: any[] = [];

        console.log(selectedPaidOrderItems);

        selectedPaidOrderItems.forEach((item: any, index: number) => {

            if (!item) return;

            if (item.totalPaymentRecords.length === 0) {
                return;
            }

            const startDate = new Date(item.startDate);
            const endDate = new Date(item.endDate);

            const startDateString = `${dateToDateString(startDate)}`;
            const endDateString = `${dateToDateString(endDate)}`;

            item.totalPaymentRecords.forEach((paymentRecord: any, index: number) => {

                const oneRow: any = {};

                oneRow.id = paymentRecord.id;
                oneRow.paymentId = paymentRecord.id;
                oneRow.studentLocation = item.location;
                oneRow.goodId = item.id;
                //재학생이면 표시용 이름에만 (재학생) 붙임
                oneRow.name = item.isEnrolledStudent === 1 ? item.name + " (재학생)" : item.name;
                oneRow.userId = item.userId;
                oneRow.price = index === 0 ? item.price.toLocaleString() : "━━━━";
                oneRow.goodName = index === 0 ? `${startDateString}~${endDateString}` : "┗━━━━━━━━━━━";

                //취소예정 상품과 기간이 겹치는 구입완료 상품 리스트 (취소예정 필터에서만 열 표시)
                if (index === 0 && item.duplicateGoodsList && item.duplicateGoodsList.length > 0) {
                    oneRow.duplicateGoodName = item.duplicateGoodsList.map((duplicate: any) => `${dateToDateString(new Date(duplicate.startDate))}~${dateToDateString(new Date(duplicate.endDate))}${duplicate.toBeCanceled ? "(취소예정)" : ""}`).join(", ");
                } else {
                    oneRow.duplicateGoodName = "";
                }
                oneRow.kindName = kindNaming(paymentRecord.kind);
                oneRow.kind = paymentRecord.kind;
                oneRow.type = paymentRecord.type;
                oneRow.status = paymentRecord.canceled ? "취소됨" : "결제완료";
                oneRow.amount = paymentRecord.price.toLocaleString();
                oneRow.amount += ` ${(item.diff_amount < 0 && !paymentRecord.canceled) ? `(잔여 ${Math.abs(item.diff_amount).toLocaleString()})` : ""}`;
                oneRow.createdAt = dateToDateString(new Date(paymentRecord.createdAt), true);
                const kindName = kindNaming(paymentRecord.type);
                oneRow.kindName = kindName;
                oneRow.data = paymentRecord.data ? paymentRecord.data : null;
                oneRow.cashReceiptPhoneNumber = item.cashReceiptPhoneNumber ? item.cashReceiptPhoneNumber : "";
                oneRow.cashReceiptFinish = paymentRecord.cashReceiptFinish ? paymentRecord.cashReceiptFinish : "";

//                 단말기 authority
// transdate, transtime

// 결제선생 
// appr_origin_num
// appr_origin_dt
// 20260317160748

                if(oneRow.kindName === "결제선생"){
                    oneRow.authority = paymentRecord.data.appr_dt ? paymentRecord.data.appr_dt : "";

                    oneRow.approvalnum = paymentRecord.data.appr_origin_num ? paymentRecord.data.appr_origin_num : "";
                    // oneRow.approvaldt = paymentRecord.data.appr_origin_dt ? dateToDateString(new Date(paymentRecord.data.appr_origin_dt), true) : "";
                    const appr_origin_dt = paymentRecord.data.appr_origin_dt ? paymentRecord.data.appr_origin_dt : "";

                    if(appr_origin_dt){
                    
                        const year = appr_origin_dt.substring(0, 4);
                        const month = appr_origin_dt.substring(4, 6);
                        const date = appr_origin_dt.substring(6, 8);
                        const hour = appr_origin_dt.substring(8, 10);
                        const minute = appr_origin_dt.substring(10, 12);
                        const second = appr_origin_dt.substring(12, 14);

                        oneRow.approvaldt = `${year}-${month}-${date} ${hour}:${minute}:${second}`;
                    }

                }

                if(oneRow.kindName === "단말기결제"){
                    oneRow.authority = paymentRecord.data.authority ? paymentRecord.data.authority : "";

                    const transDate = paymentRecord.data.transdate ? paymentRecord.data.transdate : "123";
                    const transTime = paymentRecord.data.transtime ? paymentRecord.data.transtime : "456";
                    oneRow.approvaldt = transDate && transTime ? `${transDate} ${transTime}` : "";

                    oneRow.approvalnum = paymentRecord.data.authority ? paymentRecord.data.authority : "";
                }

                if (paymentRecord.canceled) {
                    oneRow.statusNumber = "2";
                } else if (item.toBeCanceled) {
                    oneRow.statusNumber = "1";
                } else {
                    oneRow.statusNumber = "0";
                }

                if (paymentRecord.type === "forcePayment") {
                    teacherData.forEach((teacherItem: any) => {
                        const teacherId = teacherItem.id;
                        const forcedBy = paymentRecord.forcedBy;

                        if (teacherId === forcedBy) {
                            oneRow.kindName = `수동결제(${teacherItem.name})_${paymentRecord.forcedMemo}`;
                        }

                    });
                }

                oneRow.forceImg = paymentRecord.forcedImg ? paymentRecord.forcedImg : null;

                oneRow.payTeacherBillId = paymentRecord.payTeacherBillId ? paymentRecord.payTeacherBillId : null;
                oneRow.orderId = item.id;
                oneRow.toBeCanceled = item.toBeCanceled;
                oneRow.canceledAt = paymentRecord.canceled ? dateToDateString(new Date(paymentRecord.canceledAt), true) : "";
                oneRow.index = index;

                newRows.push(oneRow);

            });


        });

        setRows([...newRows]);

    }

    const kindNaming = (kind: string) => {

        var kindName = "";

        switch (kind) {
            case "card":
                kindName = "카드결제";
                break;
            case "cash":
                kindName = "현금결제";
                break;
            case "withdrawal":
                kindName = "계좌이체";
                break;
            case "kiosk":
                kindName = "키오스크결제";
                break;
            case "forcePayment":
                kindName = "수동결제";
                break;
            case "payTeacher":
                kindName = "결제선생";
                break;
            case "terminal":
                kindName = "단말기결제";
                break;
        }

        return kindName;

    }

    const handleChange = (event: React.MouseEvent<HTMLElement>, newAlignment: string | null) => {

        if (!newAlignment) return;

        setAlignment(newAlignment);

        const newFilterModel = { ...filterModel };

        var value = "";

        switch (newAlignment) {
            case "total":
                value = "";
                break;
            case "payteacher":
                value = "결제선생";
                break;
            case "terminal":
                value = "단말기결제";
                break;
            case "forcepayment":
                value = "수동결제";
                break;
            case "withdrawal":
                value = "계좌이체";
                break;
        }

        newFilterModel.items = newFilterModel.items.map((item) => {
            if (item.field === "kindName") {
                return {
                    ...item,
                    value: value
                };
            }
            return item;
        });

        setFilterModel(newFilterModel);

    };

    const searchNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const newValue = e.target.value;
        setSearchName(newValue);

        const newFilterModel = { ...filterModel };
        newFilterModel.items = newFilterModel.items.map((item) => {
            if (item.field === "name") {
                return {
                    ...item,
                    value: newValue
                };
            }
            return item;
        }
        );
        setFilterModel(newFilterModel);
    }

    const handleChange2 = (event: React.MouseEvent<HTMLElement>, newAlignment: string | null) => {

        if (!newAlignment) return;

        setAlignment2(newAlignment);

        const newFilterModel: any = { ...filterModel };

        const locationList: any = [];

        totalLocationData.forEach((location) => {

            if (newAlignment === "total") {


            } else if (location.english === newAlignment) {
                locationList.push(location.korean);
            }

        });

        newFilterModel.items.forEach((each: any) => {
            if (each.id === 5) {
                each.value = locationList;
            }
        })

        setFilterModel({ ...newFilterModel });
    }

    const handleChange3 = (event: React.MouseEvent<HTMLElement>, newAlignment: string | null) => {

        if (!newAlignment) return;

        setAlignment3(newAlignment);

        const newFilterModel: any = { ...filterModel };

        var value = "";

        switch (newAlignment) {
            case "total":
                value = "";
                break;
            case "tobecanceled":
                value = "1";
                break;
            case "canceled":
                value = "2";
                break;
        }

        newFilterModel.items = newFilterModel.items.map((item: any) => {
            if (item.field === "statusNumber") {
                return {
                    ...item,
                    value: value
                };
            }
            return item;
        });

        setFilterModel({ ...newFilterModel });
    }


    return (
        <div>
            {/* 지금으로부터 12달 전까지 선택 가능 */}
            <Select
                value={selectedMonth}
                onChange={(e, newValue) => { setSelectedMonth(newValue as string) }}
                style={{
                    marginTop: "30px",
                    width: "250px",
                    marginBottom: "20px"
                }}
            >
                {
                    Array.from({ length: 12 }, (_, i) => {
                        const now = new Date();
                        const date = new Date(now.getFullYear(), now.getMonth() + 1 - i, 1);
                        const year = date.getFullYear();
                        const month = ("0" + (date.getMonth() + 1)).slice(-2);
                        const value = `${year}-${month}`;
                        return (
                            <Option key={value} value={value}>{value}</Option>
                        )
                    })
                }
            </Select>



            <div>
                <div style={{
                    marginBottom: "10px"
                }}>
                    <ToggleButtonGroup
                        color="primary"
                        value={alignment2}
                        exclusive
                        onChange={handleChange2}
                    >
                        {
                            props.user && totalLocationData.filter((each) => each.academy.includes(props.user.academy)).map((each, index) => {
                                return (
                                    <ToggleButton value={each.english} key={index}>{each.korean}</ToggleButton>
                                )
                            })
                        }
                    </ToggleButtonGroup>
                </div>
                <div style={{
                    marginBottom: "16px",
                    display: "flex",
                    justifyContent: "space-between",
                    width: "2000px"
                }}>
                    <div>
                        <ToggleButtonGroup
                            color="primary"
                            value={alignment}
                            exclusive
                            onChange={handleChange}
                        >
                            <ToggleButton value="total">전체</ToggleButton>
                            <ToggleButton value="payteacher">결제선생</ToggleButton>
                            <ToggleButton value="terminal">단말기결제</ToggleButton>
                            <ToggleButton value="forcepayment">수동결제</ToggleButton>
                            <ToggleButton value="withdrawal">계좌이체</ToggleButton>
                        </ToggleButtonGroup>

                        <ToggleButtonGroup
                            color="primary"
                            value={alignment3}
                            exclusive
                            onChange={handleChange3}
                            sx={{
                                marginLeft: "12px"
                            }}
                        >
                            <ToggleButton value="total">전체</ToggleButton>
                            <ToggleButton value="tobecanceled">취소예정</ToggleButton>
                            <ToggleButton value="canceled">취소됨</ToggleButton>
                        </ToggleButtonGroup>
                    </div>
                    <div>
                        <InputBase
                            placeholder="학생이름으로 검색"
                            value={searchName}
                            onChange={(e: any) => {
                                searchNameChange(e);
                            }}
                            style={{
                                borderBottom: "1px solid black",
                            }}
                        />
                    </div>
                </div>

                <div className={classes.root} style={{ height: 900, width: 2000, backgroundColor: "white" }}>
                    <DataGridPremium
                        rows={rows}
                        columns={columns}
                        density="compact"
                        processRowUpdate={handleEditCommit}
                        onProcessRowUpdateError={handleProcessRowUpdateError}
                        components={{ Toolbar: GridToolbar }}
                        loading={loading}
                        onRowClick={(params: any) => {
                            console.log(params.row);
                            setSelectedRow(params.row);
                            console.log(params.row);
                            setSelectedOrderId(params.row.order_id);
                            setSelectedBillId(params.row.bill_id);
                            setSelectedIsFinish(params.row.isFinish);
                        }}
                        filterModel={filterModel}
                        onFilterModelChange={(newFilterModel) => setFilterModel(newFilterModel)}
                        getCellClassName={(params: any) => {

                            if (params.field === "status" && params.value === "결제완료") {
                                return "paid"
                            }

                            if (params.field === "status" && params.value === "취소됨") {
                                return "redtext"
                            }

                            if (params.field === "status" && params.value === "매칭 대기 중") {
                                return "important"
                            }

                            return ""
                        }}
                        columnVisibilityModel={{
                            statusNumber: false,
                            duplicateGoodName: alignment3 === "tobecanceled"
                        }}
                    />
                </div>
            </div>

            <ImageModal2
                open={open3}
                handleClose={() => { setOpen3(false) }}
                src={[imageSrc]}
            />

            <Modal
                aria-labelledby="modal-title"
                aria-describedby="modal-desc"
                open={open}
                onClose={() => {
                    setOpen(false);
                    setData(null);
                }}
                sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
            >
                <Sheet
                    variant="outlined"
                    sx={{ width: 400, borderRadius: 'md', p: 3, boxShadow: 'lg' }}
                >
                    <ModalClose variant="plain" sx={{ m: 1 }} />
                    <div style={{
                        fontFamily: "Apple_SB",
                        fontSize: "20px"
                    }}>
                        결제 내역 상세정보
                    </div>
                    <div style={{
                        marginTop: "20px"
                    }}>
                        {data && Object.entries(data).map(([key, value]) => {
                            
                        if(key === "apikey"){
                            return null;
                        }

                        return (
                            <div
                                key={key}
                                style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    padding: '6px 0',
                                    borderBottom: '1px solid #eee',
                                    fontFamily : "Apple_R"
                                }}
                            >
                                <span style={{ color: '#666' }}>{key}</span>
                                <span style={{ fontWeight: 500 }}>
                                    {String(value)}
                                </span>
                            </div>
                        )})}
                    </div>
                </Sheet>
            </Modal>


            <PaidModal
                open={paidModalOpen}
                handleClose={() => { setPaidModalOpen(false) }}
                userId={paidModalStudent ? paidModalStudent.id : 0}
                selectedPaidOrderItems={selectedPaidOrderItems2}
                notify8={notify8}
                notify9={notify9}
                notify16={notify16}
                notify18={notify18}
                setUpdate={setUpdate}
                update={update}
                totalTeacherData={totalTeacherData}
                registerPayInfo={registerPayInfo}
                selectedStudent={paidModalStudent}
            />

            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={submitLoading}
            >
                <CircularProgress color="inherit" />
            </Backdrop>

        </div>
    )
}

export default TotalPayementList;